import * as angular from 'angular';

export type MimeType = 'text/xml';

export class FileService {
    constructor(
        private $window: angular.IWindowService,
        private $document: angular.IDocumentService
    ) {}

    public triggerFileDownload(
        data: string | Array<string>,
        filenameWithExt: string,
        mimeType: MimeType
    ): boolean {
        const blob: Blob = new Blob(angular.isArray(data) ? data : [data], {
            type: mimeType
        });

        if (this.$window.navigator.msSaveOrOpenBlob) {
            return this.$window.navigator.msSaveBlob(blob, filenameWithExt);
        }

        const document: HTMLElement & Document = this.$document[0];
        const elem: HTMLAnchorElement = document.createElement('a');

        elem.href = this.$window.URL.createObjectURL(blob);
        elem.download = filenameWithExt;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);

        return true;
    }
}

angular.module('app').service('fileService', FileService);
